import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialFormState: Dtos.TrialForm & IRegistrationFormState = {
    id: null,
    trialId: null,
    trial: null,
    institutionId: null,
    institution: null,
    patientId: null,
    patient: null,
    formTemplateId: null,
    formTemplate: null,
    formStatusId: null,
    formStatus: null,
    version: null,
    assignedToId: null,
    assignedTo: null,
    assignedDisplay: null,
    assignedRole: null,
    assignedRoleId: null,
    assignmentTypeId: 1,
    formNextAutoVersionId: null,
    formNextAutoVersion: null,
    dateNextVersion: null,
    collectionInstanceId: null,
    collectionInstance: null,
    reminderEmailDateSend: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
    versions: []
}

export interface ITrialFormReduxFormState {
    id: IFieldState<number>,
    trialId: IFieldState<number>,
    trial: IFieldState<Dtos.Trial>,
    institutionId: IFieldState<number>,
    institution: IFieldState<Dtos.Institution>,
    patientId: IFieldState<number>,
    patient: IFieldState<Dtos.Patient>,
    formTemplateId: IFieldState<number>,
    formTemplate: IFieldState<Dtos.FormTemplate>,
    formStatusId: IFieldState<number>,
    formStatus: IFieldState<Dtos.FormStatus>,
    version: IFieldState<string>,
    assignedToId: IFieldState<number>,
    assignedTo: IFieldState<Dtos.Personnel>,
    assignedRoleId: IFieldState<number>,
    assignmentTypeId: IFieldState<number>,
    formNextAutoVersionId: IFieldState<number>,
    formNextAutoVersion: IFieldState<Dtos.FormNextAutoVersion>,
    dateNextVersion: IFieldState<string>,
    collectionInstanceId: IFieldState<number>,
    collectionInstance: IFieldState<Dtos.CollectionInstance>,
    reminderEmailDateSend: IFieldState<string>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    message: IFieldState<string>,
    openedModals: IFieldState<string[]>,
    versions: IFieldState<Dtos.TrialForm[]>
}
